import React from "react";
import Header from "../../patterns/header/header";
import LanguageSelector from "../../components/languageSelector/languageSelector";
import {Box} from "@mui/material";
import Footer from "../../patterns/footer/footer";

const privateRoute = (component: JSX.Element, isMobile: boolean, setOpenCookieDialog: (openCookieDialog: boolean) => void): JSX.Element => {
  return (
    <>
      <Header/>
      <LanguageSelector />
      <Box sx={{minHeight: !isMobile ? "calc(100vh - 181px)" : "calc(100vh - 292px)"}}>
        {component}
      </Box>
      <Footer setOpenCookieDialog={setOpenCookieDialog}/>
    </>
  )
}

export default privateRoute;
